// Custom Event is Partially Supported in IE11
import { WINDOW } from './environment'

const createNewEvent = (eventName) => {
  if (!WINDOW) return

  if(typeof(Event) === 'function') {
    const event = new Event(eventName);
    return event
  }

  const event = WINDOW.document.createEvent('Event');
  event.initEvent(eventName, true, true);
  return event
}

const dispatchEvent = (event) => {
  if (!WINDOW) return
  if (!WINDOW.dispatchEvent) return

  WINDOW.dispatchEvent(event)
}


export {
  createNewEvent,
  dispatchEvent
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/newEvent.js